import { Link } from 'react-router-dom';

export function SecurityPage() {
  return (
    <>
      <section className="bg-inverse px-6 pt-28 pb-16 lg:px-10 lg:pt-36 lg:pb-20">
        <div className="mx-auto max-w-[1280px]">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-brand/30 bg-brand/20 px-3 py-1.5 text-[0.72rem] font-bold tracking-widest text-brand uppercase">
            Security
          </div>
          <h1 className="font-display mb-5 max-w-[16ch] text-[2.75rem] leading-[1.06] font-extrabold text-inverse-fg lg:text-[3.375rem]">
            Your business data is business-critical.
          </h1>
          <p className="max-w-[48ch] text-[1.0625rem] leading-[1.7] text-inverse-fg/50">
            cevop is built so your records are accurate, your data is protected and your access is controlled. No vague
            claims — specific, verifiable controls.
          </p>
        </div>
      </section>

      <section className="px-6 py-20 lg:px-10 lg:py-28">
        <div className="mk-stagger mx-auto grid max-w-[1280px] gap-5 lg:grid-cols-2">
          {[
            {
              title: 'Role-based access control',
              body: 'Cashiers, branch managers, managers, accountants, and owners have different capabilities. Access is enforced on the server.',
            },
            {
              title: 'Full audit trail',
              body: 'Voids, refunds, stock adjustments and sensitive settings changes leave audit trails with actor and time.',
            },
            {
              title: 'Tenant isolation',
              body: 'Every query is scoped to your organisation. One shop never sees another’s data.',
            },
            {
              title: 'Encryption in transit',
              body: 'Traffic uses HTTPS/TLS. We do not store card numbers — POS records payment method labels only.',
            },
            {
              title: 'Account and session security',
              body: 'Passwords are hashed. Sessions use short-lived access tokens and rotating refresh tokens. Sign out invalidates the session.',
            },
            {
              title: 'Data resilience',
              body: 'Business data is stored with backups on managed infrastructure. Export reports regularly for your own records.',
            },
          ].map((item) => (
            <div key={item.title} className="mk-lift rounded-2xl border border-line bg-panel p-7 shadow-sm">
              <h3 className="font-display mb-3 text-[1.05rem] font-bold text-ink">{item.title}</h3>
              <p className="text-[0.85rem] leading-[1.7] text-ink-3">{item.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-y border-line bg-surface-2/60 px-6 py-16 lg:px-10">
        <div className="mx-auto max-w-[760px] text-center">
          <h2 className="font-display mb-4 text-[1.75rem] font-extrabold text-ink">Our security principle</h2>
          <p className="mb-8 text-[1rem] leading-[1.7] text-ink-3">
            cevop will not describe security in terms that cannot be verified — no “bank-level security.” If you
            identify a concern, report it so we can address it.
          </p>
          <a
            href="mailto:security@cevop.com"
            className="inline-flex items-center rounded-xl bg-brand px-5 py-2.5 text-[0.875rem] font-semibold text-brand-on hover:bg-brand-hover"
          >
            Report a concern — security@cevop.com
          </a>
        </div>
      </section>

      <section className="px-6 py-14 lg:px-10">
        <div className="mx-auto flex max-w-[640px] flex-col justify-center gap-3 text-center sm:flex-row">
          <Link
            to="/help/security"
            className="inline-flex items-center justify-center rounded-xl border border-line-strong px-6 py-3 font-semibold text-ink hover:bg-surface-2"
          >
            Security help article
          </Link>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center rounded-xl bg-brand px-6 py-3 font-semibold text-brand-on hover:bg-brand-hover"
          >
            Contact us
          </Link>
        </div>
      </section>
    </>
  );
}
